import classNames from "classnames";
import { createUseStyles } from "react-jss";
import { Field } from "@base-ui-components/react";

interface Props {
  className?: string;
  label?: string;
  placeholder?: string;
  errorMessage?: string;
  description?: string;
  onChange: (name: any, value: any) => void;
  required?: boolean;
  value?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  type?: string;
  name?: string;
}

const useStyles = createUseStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: " 0.25rem",
    width: "100%",
  },
  label: {
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    fontWeight: "bold",
  },
  input: {
    boxSizing: "border-box",
    paddingLeft: "0.875rem",
    paddingRight: "0.875rem",
    margin: 0,
    border: "1px solid #e4e5eb",
    width: "100%",
    height: "3.5rem",
    borderRadius: "0.375rem",
    fontFamily: "inherit",
    fontSize: "1rem",
    backgroundColor: "transparent",
    color: "#4a4a4a",
    "&:focus": {
      outline: "2px solid #F6BB60",
      outlineOffset: "-1px",
    },
    "& i": {
      color: "red",
    },
  },
  error: {
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    color: "red",
  },
  description: {
    margin: 0,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    color: "#4a4a4a",
  },
});

const Input = ({
  className,
  label,
  placeholder,
  errorMessage,
  description,
  onChange,
  required = false,
  value,
  onBlur,
  onFocus,
  type = "text",
  name,
}: Props) => {
  const classes = useStyles();
  return (
    <Field.Root
      className={classNames(classes.root, className)}
      onChange={(event) => {
        const eventTarget = event.target as HTMLInputElement;
        onChange(eventTarget.name, eventTarget.value);
      }}
      onBlur={onBlur}
      onFocus={onFocus}
    >
      <Field.Label className={classes.label}>{label}</Field.Label>
      <Field.Control
        required={required}
        placeholder={placeholder}
        className={classes.input}
        value={value}
        type={type}
        name={name}
      />

      <Field.Error className={classes.error} match="valueMissing">
        {errorMessage}
      </Field.Error>

      <Field.Description className={classes.description}>
        {description}
      </Field.Description>
    </Field.Root>
  );
};

export default Input;
